import '../../common/Mypage.scss';
import MypageMenu from '../../common/MypageMenu';
import { Link } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import { loginStateAtom, userDataAtom } from '../../../../AtomStore';
import ServicePaymentList from '../../common/ServicePaymentList';

export default function ServiceManage() {
  const isLogin = useAtomValue(loginStateAtom);
  const userAccount = useAtomValue(userDataAtom)?.userAccount?.trim() || '';

  return (
    <div className="mypage">
      <div className="inner">
        <MypageMenu />
        <div className="subpage__main">
          <div className="mypage-panel mypage-section-card">
            <h2 className="mypage-section-title">서비스 관리</h2>
            <p className="service-manage__lead">
              결제하신 서비스 내역을 확인할 수 있습니다.
            </p>
          <div style={{ marginTop: 18 }}>
            {!isLogin || !userAccount ? (
              <div className="noPosts">
                <p>로그인 후 결제 내역을 확인할 수 있습니다.</p>
                <p style={{ marginTop: 12 }}>
                  <Link to="/login" className="service-manage__login-link">
                    로그인하기
                  </Link>
                </p>
              </div>
            ) : (
              <ServicePaymentList userAccount={userAccount} />
            )}
          </div>
          </div>
        </div>
      </div>
    </div>
  );
}
